<template>
  <div style="margin-left: 0px;">
    <div v-if="debug_show_page_name==true" style="color:green;">device-management-ledger-modal</div>
    <modal
      class="file-modal"
      width="1500px"
      :value="showModal"
      effect="fade"
      @closed="closed"
      large
    >
    <div class="modal-body">
      <div :class="'container ' + pageContainerSize" style="margin-right: auto;  margin-left: auto;">
        <ag-grid-vue style="width: 100%; height: 100px;" class="ag-blue" :gridOptions="gridOptions"></ag-grid-vue>
      </div>
      <div class="row ">
    　　　<br>
          <div class=" col-xs-5" style=" margin-left: 120px;">
          <field-box   v-for="f in formFields.col1"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly"  :val="values[f.id]"></field-box>
        </div>
        <div class="col-xs-5" style="">
          <field-box   v-for="f in formFields.col2"  v-bind:key="f.id" v-bind:data="f"  :read="readOnly"  :val="values[f.id]"></field-box>
        </div>
      </div>
    </div>
    <div slot="modal-footer" class="modal-footer" style="background:white">
      <button type="button" class="btn btn-primary" @click="closed('yes')">閉じる</button>
    </div>
  </modal>
  </div>
</template>

<script>
import deviceembeddedinformationaddcheck from '@/components/modals/device-embedded-information-add_check';
import Vue from "vue";
import { AgGridVue } from "ag-grid-vue";
import { fields, filed_types } from "@/rules/fields_device_embedded_detail";
import { utils } from "@/libs/utils";
import fieldBoxes from '@/components/form-field';

import _debug from "debug";
var mdebug = _debug("esma:device_embedded_detail");
import acl from "@/rules/acl_rules";
import mixinPageCommon from "@/mixins/mixin_page_common";
import mixinDatasource from "@/mixins/mixin_datasource";
import { bus } from "@/libs/bus";
// import yobikiModal from "@/components/modals/yobiki-modal";
// Vue.component("yobiki-modal", yobikiModal);
import constants from '@/rules/constants';
import modal from "./local-modal";

Vue.component("modal", modal);
import _ from "lodash";
import debug from "debug";
var debug_file = debug("esma:file-modal");

export default {
  mixins: [mixinPageCommon, mixinDatasource],
  components: {
    "ag-grid-vue": AgGridVue,
    'field-box': fieldBoxes
  },
  data() {
    return {
      api_name: "device_embedded_detail",
      page_acl: acl.generic,
      detail_page: "page_0015_device_embedded_information_pegging",
      detail_page_url: "/device_embedded_information_pegging/",
      state_current_editing:"current_editing2",
      state_current_row:"current_row2",
      state_is_editing_new:"is_editing_new2",
      state_last_filter_options:"last_filter_options2",
      temp_certificate_management_number:"",
      local_fk_id: -1,
      show_modal: false,
      device_management_ledger:{},
      overlay_check_delay:3000
    };
  },
  computed: {
    showModal: {
      get() {
        return this.show_modal;
      },
      set(v) {
        this.show_modal = v;
      },
    },
    readOnly:{
      get(){
        return this.read_only;
      },
      set(v){
        this.read_only = v;
      }
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields() {
      return this.tabFieldList;
    },
    values() {
      console.log("values");
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    tabFieldList() {
      return [
        // this.local_extend( fields.ref_id, {}),
        this.local_extend( fields.jurisdiction_classification, {}),
        this.local_extend( fields.department_in_charge, {}),
        this.local_extend( fields.responsible_team, {}),
        this.local_extend( fields.jurisdiction_system, {}),
        this.local_extend( fields.jurisdiction_system_name_in_use, {}),
        this.local_extend( fields.maker, {}),
        this.local_extend( fields.software, {}),
        this.local_extend( fields.software_jurisdiction, {}),
        this.local_extend( fields.item_number, {}),
        this.local_extend( fields.virtual_id, {}),
        this.local_extend( fields.certificate_management_number, {})
      ];
    },
    formFields() {
      return {
        col1:[
          this.local_extend(fields.jurisdiction_classification, {}),
          this.local_extend(fields.department_in_charge, {}),
          this.local_extend(fields.responsible_team, {}),
          this.local_extend(fields.jurisdiction_system, {}),
          this.local_extend(fields.jurisdiction_system_name_in_use, {}),
          this.local_extend(fields.maker, {}),
        ],
        col2:[
          this.local_extend(fields.software, {}),
          this.local_extend(fields.software_jurisdiction, {}),
          this.local_extend(fields.item_number, {}),
          this.local_extend(fields.virtual_id, {}),
          this.local_extend(fields.certificate_management_number, {}),
        ]
      }
    }
  },
  methods: {
    closed() {
      this.setAsZeroRows();
      this.$emit("close", {});
      this.showModal = false;
    },
    local_extend(field_info,ext){
      ext.state_current_row = this.stateCurrentRow;
      ext.state_current_editing = this.stateCurrentEditing;
      return utils.extend(field_info,ext)
    },
    onSubTableDeviceEmbeddedInformationAddCheckConfirm(mode){
        this.readOnly = false;
        this.commonSaveInfo(this,this.api_name, {} );
    },
    createColumnDefs() {
        return this.commonCreateColumnDefs({show_details:false,show_checkbox:false})
    },
    onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
      this.commonOnRowSelected(this, ev, this.api_name,(vm)=>{
      })
    },
    localLoadData(id){
      this.searchControlChangedDatasource(this.singleSearchCreate("fk_id","" +id))

    },
     showModalWindow(data) {

      this.fkId = data.fk_id;
      this.error_msg = "";
      this.showModal = true;
      this.localLoadData(data.fk_id)
      this.gridOptions.api.sizeColumnsToFit();
    },
  },
  mounted() {
    debug_file("On mounted");
    bus.$on(this.$props.tag, this.showModalWindow);
  },
  beforeMount() {
    this.$store.state[this.stateCurrentRow] = {};
    this.gridOptions = _.extend(this.commonGridOptions, {});
    this.initDatasource({ load_only_with_filter:true});
  },
  beforeDestroy() {
    bus.$off(this.$props.tag);
  },
  props: {
    ref_id: { type: String, default: "" },
    // fk_id: { type: Number, default: "" },
    tag_reload: { type: String, default: "" },
    disable_new_btn: { type: Boolean, default: false },
    disable_edit_btn: { type: Boolean, default: false },
    hide_new_btn: { type: Boolean, default: false },
    hide_edit_btn: { type: Boolean, default: false },
    tag: { type: String, default: "showfileModal" },
  },
};
</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// device-management-ledger-modal.vue?f732b996